export const GET_STARTED = 'get-started';
export const LEAD_GENERATOR = 'lead-generator';
export const METRICS = 'metrics';

export const BOOST_CONNECTED = 'connected';
export const BOOST_DISCONNECTED = 'disconnected';
export const BOOST_PENDING_FIRST_BUY = 'connected';
